/* eslint-disable no-restricted-syntax */
import { default as React } from 'react';
import { Entity } from '@backstage/catalog-model';
import { useEntity, EntityProvider } from '@backstage/plugin-catalog-react';
import { EntityArgoCDOverviewCard } from '@roadiehq/backstage-plugin-argo-cd';

interface Props {
  environment: 'production' | 'staging';
  title: string;
  entity?: Entity;
}

/**
 * Environment-aware ArgoCD card wrapper.
 *
 * Both staging and production microapps use the SAME ArgoCD instance.
 * The difference is the ArgoCD app name suffix:
 * - Production: `plateng-...-{app-name}`
 * - Staging: `plateng-...-{app-name}-staging`
 *
 * The `entity` prop should have the correct `argocd/app-name` annotation
 * set by the parent component (MicroappArgoCDCard).
 *
 * IMPORTANT: The Roadie EntityArgoCDOverviewCard uses useEntity() internally,
 * ignoring any entity prop. We must wrap it in EntityProvider to override
 * the context entity.
 *
 * IDP-1175: Fix for staging/production ArgoCD card rendering
 */
export const EnvironmentAwareArgoCDCard = ({
  title,
  entity: entityProp,
}: Props) => {
  const { entity: contextEntity } = useEntity();

  // Use provided entity or fall back to context
  const entity = entityProp || contextEntity;

  // Wrap in EntityProvider to override the context entity
  // This ensures the Roadie plugin reads the correct argocd/app-name
  return (
    <EntityProvider entity={entity}>
      <EntityArgoCDOverviewCard title={title} />
    </EntityProvider>
  );
};
